import GPXService from '@/api/map/gpx/gpxService'

export default {
  export (store, data) {
    const { huntAreaId, exportData } = data

    return GPXService.export(huntAreaId, exportData)
  }
}
